import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationBlConstants {
    static STEP_TITLE = "Location";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static LAYER_REF = "Property graphics";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static PROPERTY_REQUIRED = "Please select a property before saving or continuing with the application process";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static UNIT_NUMBER_CONTROL = "unitNumber";
    static SHOP_NUMBER_CONTROL = "shopNumber";
    static TITLE_DEED_NUMBER_CONTROL = "titleDeedNumber";
    static NAME_OF_ACCOMMODATION_CONTROL = "accommodationName";
    static TITLE_DEED_DESCRIPTION_CONTROL = "titleDeedDescription";
    static PROPERTIES_FORM_CONTROL = "properties";
    static PROPERTIES_FORM_GROUP_NAME = "propertiesForm";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static UNIT_NUMBER_PLACEHOLDER = "Unit number";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size";
    static SHOP_NUMBER_TEXT_PLACEHOLDER = "Shop number";
    static TITLE_DEED_NUMBER_TEXT_PLACEHOLDER = "Title deed number (Lot number)";
    static NAME_OF_ACCOMMODATION_TEXT_PLACEHOLDER = "Name of accommodation";
    static TITLE_DEED_DESCRIPTION_TEXT_PLACEHOLDER = "Title deed description";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static ONLY_ONE_PROPERTY_ALLOWED = "Only one property can be added per application.";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, titleDeedNumber: {
            required: `Title deed number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, titleDeedDescription: {
            required: `Title deed description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
